module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "chosen",
    attrs: {
      "data-placeholder": _vm.placeholder,
      "multiple": _vm.multiple
    }
  }, [(!_vm.hasGroups) ? _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n        ")])
  }) : _vm._e(), _vm._v(" "), (_vm.hasGroups) ? _vm._l((_vm.options), function(group, label) {
    return _c('optgroup', {
      attrs: {
        "label": label
      }
    }, _vm._l((group), function(option) {
      return _c('option', {
        domProps: {
          "value": option.id
        }
      }, [_vm._v("\n                " + _vm._s(option.label) + "\n            ")])
    }))
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b95b1ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueChosen.vue
// module id = 1094
// module chunks = 0